module.exports = __webpack_public_path__ + "static/media/nulltx.f89372aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/nulltx.png
// module id = 1807
// module chunks = 146